import { RouteObject } from "react-router";

import { Auth } from "./layouts/auth";
import { Root } from "./layouts/root";
import { AccountPage } from "./pages/account-page";
import { ErrorPage } from "./pages/error-page";
import { HomePage } from "./pages/home-page";
import { RedirectTranscriptionPage } from "./pages/redirect-transcription-page";
import { TranscriptionConfigPage } from "./pages/transcription-config-page";
import { TranscriptionLayoutPage } from "./pages/transcription-layout-page";
import { TranscriptionPage } from "./pages/transcription-page";
import { TranscriptionsPage } from "./pages/transcriptions-page";

export const routes: RouteObject[] = [
  {
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      { path: "/", element: <HomePage /> },
      {
        path: "/transcription/:transcriptId?",
        element: <RedirectTranscriptionPage />,
      },
      {
        element: <Auth />,
        children: [
          { path: "/account", element: <AccountPage /> },
          { path: "/transcriptions", element: <TranscriptionsPage /> },
          {
            element: <TranscriptionLayoutPage />,
            children: [
              {
                path: "/transcriptions/new/batch",
                element: <TranscriptionConfigPage />,
              },
              {
                path: "/transcriptions/:transcriptId",
                element: <TranscriptionPage />,
              },
            ],
          },
        ],
      },
    ],
  },
];
